import { render, staticRenderFns } from "./approved.vue?vue&type=template&id=f27f16b2&scoped=true"
import script from "./approved.vue?vue&type=script&lang=js"
export * from "./approved.vue?vue&type=script&lang=js"
import style0 from "./approved.vue?vue&type=style&index=0&id=f27f16b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27f16b2",
  null
  
)

export default component.exports